<template>
  <vs-row class="border-bottom">
    <vs-col vs-w="9">
      <div class="widget-card-header"> {{ title | capitalize }}</div>
    </vs-col>
    <vs-col vs-type="flex" vs-justify="flex-end" vs-w="3" >
        <slot></slot>
    </vs-col>
  </vs-row>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: '',
    },
  },
}
</script>

<style>
</style>